// removed by extract-text-webpack-plugin
module.exports = {"root":"erZa-XWmJ2kbsulMcR_46","header":"_6Z14tnShaF7AFING5l8zc","media-wrapper":"_3T2Utyuc7HNGcS1PWQm16F","media":"_3Cv-aoYk8_h8FkmlLoiBIu","delete-btn":"_3_B0g8wdKDQL16XdD_U8an","play-media":"_3kfgnB-yDirufrVxWxbFKH","media-upload-label":"_1FAXWRxwYM3k_tsMU3ERNY","table-header-cell":"JXHtEGgf_o8-C3wtFkIRr","table-header-number":"i3bvrK5QOaDTlUXK-c-JS","center_bottom_line":"_1fMSdVEuY3CR2qOnI6AunZ","row":"_2CBW8fv2Cp3l5RYm-qef8x","col":"_1FVwiSZqsaxRHis6C8ph6M","appeal-button-col":"_2SjYrvwc2PrjvhTcwOXAMg","appeal-button":"GosHkIIdv2K7zlvC4ahIq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/submissions/show/index.scss
// module id = 1695
// module chunks = 0